export default "__VITE_ASSET__8ZJ7Dpks__"